import { Fragment } from 'react';
import { FixedSizeList } from 'react-window';
import FieldNames from '../defaults/FieldNames.json';
import { ListItem } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import './ListCard.css';
import fieldsDefinition from './details/FieldInfo.json';
import ColorConstants from '../defaults/ColorConstants';
import { getListCard } from '../utils/ListCardHelper';
import {useSelector} from "react-redux";

const theme = createTheme({
  overrides: {
  }
});

const useStyles = makeStyles({
  saveSpace: {
    paddingTop: '0px!important'
  },
  saveSpaceCarryover: {
    paddingTop: '0px!important',
    backgroundColor: ColorConstants.CarryOver
  },
  padding: {
    padding: "0px 8px"
  }
});

const ListCard = ({height, width, data, featureClicked, selectFeature, onGroupEdit,
  createActual, reportActual, navigateToEstimated, listOpen, cardSize, isGroupingsLoading}) => {
  const classes = useStyles();
  const isDraggable = false;

  const userInfo = useSelector((state) => state.globalContext.userInfo);
  const listCheckedFeatures = useSelector((state) => state.displayState.listCheckedFeatures);

  const Row = (props) => {
    const {index, style, data} = props;
    const {featureData, featureClicked, selectFeature,
      onGroupEdit, createActual, reportActual, isListOpen, cardSizes, isGroupingsLoading} = data;
    const gutter = 5;
    const feature = (data && featureData) ? featureData[index] : null;
    const featureAttr = feature ? feature : null;
    const id = feature ? feature[FieldNames.featureFields.id] : "";
  
    if(featureAttr){
      const objectId = featureAttr[FieldNames.featureFields.objectID];
      const backgroundClass = featureAttr[FieldNames.featureFields.isCarryover] === FieldNames.yesNo.yes ? classes.saveSpaceCarryover : classes.saveSpace;
      
      const conditionalItems = {
        objectId: objectId, 
        onClicked: featureClicked, 
        selectedFeatures: listCheckedFeatures, 
        selectFeature: selectFeature, 
        createActual: createActual, 
        reportActual: reportActual,
        navigateToEstimated: navigateToEstimated, 
        isGroupingsLoading: isGroupingsLoading, 
        onGroupEdit: onGroupEdit, 
      }
      
      const cardStyles = {
        styleHeight: style?.height ? style.height - gutter : 165,
        styleWidth: style?.width ? style.width : '100%',
        cardSizes: cardSizes, 
        arrowListCard : isListOpen ? 'list-normal' : 'list-just-arrow', 
        backgroundClassListCard: isListOpen ? `${backgroundClass}` : `list-hidden ${backgroundClass}`, 
        classesListCard: isListOpen ? `${classes.saveSpace}` : `list-hidden ${classes.saveSpace}`,
        backgroundClass: backgroundClass
      }
      
      return (
        <ThemeProvider theme={theme}>
          <ListItem style={style} key={index} component="div" className={classes.padding}>
          {getListCard(id, featureAttr, isDraggable, cardStyles, conditionalItems)}
          </ListItem>
        </ThemeProvider>
      )
    } else {
      return (<Fragment></Fragment>)
    }
  }
  return (<FixedSizeList
    height={height}
    width={width}
    itemCount={data?.length}
    itemSize={cardSize === FieldNames.listCardTypes.condensed ? 50 : 170}
    overscanCount={5}
    itemData={{ featureData: data, fieldsDefinition: fieldsDefinition, featureClicked: featureClicked, 
      selectFeature: selectFeature, selectedFeatures: listCheckedFeatures, onGroupEdit: onGroupEdit, isGroupingsLoading: isGroupingsLoading,
      createActual: createActual, reportActual: reportActual, isListOpen: listOpen, cardSizes: cardSize, userInfo: userInfo}}
    className="list-container"
  >
    {Row}
  </FixedSizeList>)
};

export default ListCard;